/*
 * Public API Surface of pepperi-lib/attachment
 */
export * from './attachment.module';
export * from './attachment.component';
